module.exports = __webpack_public_path__ + "static/media/laser_LENS_red.6c3f2969.png";